/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', () => {
    const sizeButtonSelector = '.size-filter-btn';
    const collectionSectionSelector = '.collection';
    const filtersContainerSelector = '.sidebar-filters, .facets__sidebar, .filters';
    const sizeInputName = 'filter.v.option.size';
    const availabilityName = 'filter.v.availability';
    const availabilityValue = '1';

    const sizeToUK = {
      'XXS': 'UK 4 - 6',
      'XS': 'UK 6 - 8',
      'S': 'UK 8 - 10',
      'M': 'UK 10 - 12',
      'L': 'UK 12 - 14',
      'XL': 'UK 14 - 16',
      'XXL': 'UK 16 - 18'
    };

    const filterButtons = Array.from(document.querySelectorAll(sizeButtonSelector));
    if (!filterButtons.length) return;
    const collectionSection = document.querySelector(collectionSectionSelector);
    const filtersContainer = document.querySelector(filtersContainerSelector) || document;


    const buttonData = filterButtons.map(button => {
      const size = button.getAttribute('data-filter') || '';
      const escapedSize = CSS.escape(size);
      const sizeSel = `input[name="${sizeInputName}"][value="${escapedSize}"]`;
      const ukSize = sizeToUK[size] || '';
      const escapedUK = ukSize ? CSS.escape(ukSize) : '';
      const ukSel = ukSize ? `input[name="${sizeInputName}"][value="${escapedUK}"]` : null;
      return { button, size, sizeSel, ukSize, ukSel };
    });

    const escapedAvailVal = CSS.escape(availabilityValue);
    const availSel = `input[name="${availabilityName}"][value="${escapedAvailVal}"]`;
    let availabilitySelectorValid = !!document.querySelector(availSel);
    if (!availabilitySelectorValid) {
      console.warn(`Availability checkbox not found: ${availSel}`);
    }

    function updateButtonStates() {
      buttonData.forEach(({ button, sizeSel, ukSel }) => {
        let isActive = false;
        const chk = document.querySelector(sizeSel);
        if (chk && chk.checked) {
          isActive = true;
        } else if (ukSel) {
          const ukChk = document.querySelector(ukSel);
          if (ukChk && ukChk.checked) isActive = true;
        }
        button.classList.toggle('active', isActive);
      });
    }

    function ensureAvailabilityOn() {
      if (!availabilitySelectorValid) return;
      const availabilityCheckbox = document.querySelector(availSel);
      if (availabilityCheckbox && !availabilityCheckbox.checked) {
        availabilityCheckbox.click();
      }
    }

    function onSizeButtonClick(e) {
      const button = e.currentTarget;
      const data = buttonData.find(d => d.button === button);
      if (!data || !data.size) return;
      const { sizeSel, ukSel } = data;
      const chk = document.querySelector(sizeSel);
      const ukChk = ukSel ? document.querySelector(ukSel) : null;
      const checked = (chk && chk.checked) || (ukChk && ukChk.checked);
      if (checked) {
        if (chk && chk.checked) chk.click();
        if (ukChk && ukChk.checked) ukChk.click();
      } else {
        if (chk && !chk.checked) chk.click();
        if (ukChk && !ukChk.checked) ukChk.click();
      }
      ensureAvailabilityOn();
      setTimeout(updateButtonStates, 100);
    }

    filterButtons.forEach(button => button.addEventListener('click', onSizeButtonClick));

    filtersContainer.addEventListener('change', e => {
      const tgt = e.target;
      if (!(tgt instanceof HTMLInputElement)) return;
      const name = tgt.getAttribute('name');
      if (name === sizeInputName || name === availabilityName) updateButtonStates();
    });

    if (collectionSection) {
      let timer;
      const observer = new MutationObserver(() => {
        clearTimeout(timer);
        timer = setTimeout(updateButtonStates, 100);
      });
      observer.observe(collectionSection, { childList: true, subtree: true });
    }

    updateButtonStates();
  });


  document.addEventListener('DOMContentLoaded', () => {
    // Updated to match your new markup
    const sizeButtonSelector = '#pwctbfcm-size-filters .pwctbfcm-size-filter-btn';
  
    // Keep existing fallbacks/selectors for the rest of the page
    const collectionSectionSelector = '.collection';
    const filtersContainerSelector = '.sidebar-filters, .facets__sidebar, .filters';
    const sizeInputName = 'filter.v.option.size';
    const availabilityName = 'filter.v.availability';
    const availabilityValue = '1';
  
    const sizeToUK = {
      'XXS': 'UK 4 - 6',
      'XS':  'UK 6 - 8',
      'S':   'UK 8 - 10',
      'M':   'UK 10 - 12',
      'L':   'UK 12 - 14',
      'XL':  'UK 14 - 16',
      'XXL': 'UK 16 - 18'
    };
  
    // Scope button lookup to the new container if present
    const sizeFilterRoot = document.getElementById('pwctbfcm-size-filters') || document;
    const filterButtons = Array.from(sizeFilterRoot.querySelectorAll(sizeButtonSelector));
    if (!filterButtons.length) return;
  
    const collectionSection = document.querySelector(collectionSectionSelector);
    const filtersContainer = document.querySelector(filtersContainerSelector) || document;
  
    const buttonData = filterButtons.map(button => {
      const size = button.getAttribute('data-filter') || '';
      const escapedSize = CSS.escape(size);
      const sizeSel = `input[name="${sizeInputName}"][value="${escapedSize}"]`;
      const ukSize = sizeToUK[size] || '';
      const escapedUK = ukSize ? CSS.escape(ukSize) : '';
      const ukSel = ukSize ? `input[name="${sizeInputName}"][value="${escapedUK}"]` : null;
      return { button, size, sizeSel, ukSize, ukSel };
    });
  
    const escapedAvailVal = CSS.escape(availabilityValue);
    const availSel = `input[name="${availabilityName}"][value="${escapedAvailVal}"]`;
    let availabilitySelectorValid = !!document.querySelector(availSel);
    if (!availabilitySelectorValid) {
      console.warn(`Availability checkbox not found: ${availSel}`);
    }
  
    function updateButtonStates() {
      buttonData.forEach(({ button, sizeSel, ukSel }) => {
        let isActive = false;
        const chk = document.querySelector(sizeSel);
        if (chk && chk.checked) {
          isActive = true;
        } else if (ukSel) {
          const ukChk = document.querySelector(ukSel);
          if (ukChk && ukChk.checked) isActive = true;
        }
        button.classList.toggle('active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
    }
  
    function ensureAvailabilityOn() {
      if (!availabilitySelectorValid) return;
      const availabilityCheckbox = document.querySelector(availSel);
      if (availabilityCheckbox && !availabilityCheckbox.checked) {
        availabilityCheckbox.click();
      }
    }
  
    function onSizeButtonClick(e) {
      const button = e.currentTarget;
      const data = buttonData.find(d => d.button === button);
      if (!data || !data.size) return;
  
      const { sizeSel, ukSel } = data;
      const chk = document.querySelector(sizeSel);
      const ukChk = ukSel ? document.querySelector(ukSel) : null;
  
      const checked = (chk && chk.checked) || (ukChk && ukChk.checked);
  
      if (checked) {
        if (chk && chk.checked) chk.click();
        if (ukChk && ukChk.checked) ukChk.click();
      } else {
        if (chk && !chk.checked) chk.click();
        if (ukChk && !ukChk.checked) ukChk.click();
      }
  
      ensureAvailabilityOn();
      setTimeout(updateButtonStates, 100);
    }
  
    filterButtons.forEach(button => button.addEventListener('click', onSizeButtonClick));
  
    filtersContainer.addEventListener('change', e => {
      const tgt = e.target;
      if (!(tgt instanceof HTMLInputElement)) return;
      const name = tgt.getAttribute('name');
      if (name === sizeInputName || name === availabilityName) updateButtonStates();
    });
  
    if (collectionSection) {
      let timer;
      const observer = new MutationObserver(() => {
        clearTimeout(timer);
        timer = setTimeout(updateButtonStates, 100);
      });
      observer.observe(collectionSection, { childList: true, subtree: true });
    }
  
    updateButtonStates();
  });
  

  document.addEventListener('DOMContentLoaded', () => {
    // Button selector and scoping for the product-type button row
    const btnSelector = '#pwctbfcm-ptype-filters .pwctbfcm-ptype-filter-btn';
    const btnRoot = document.getElementById('pwctbfcm-ptype-filters') || document;
    const buttons = Array.from(btnRoot.querySelectorAll(btnSelector));
    if (!buttons.length) return;
  
    // Existing collection/facets containers (kept broad to work across themes)
    const collectionSectionSelector = '.collection';
    const filtersContainerSelector = '.sidebar-filters, .facets__sidebar, .filters, .filter-group__body';
    const collectionSection = document.querySelector(collectionSectionSelector);
    const filtersContainer = document.querySelector(filtersContainerSelector) || document;
  
    // The existing product type filter inputs
    const productTypeInputName = 'filter.p.product_type';
  
    // Wire button metadata to corresponding checkbox selectors (CSS-escaped)
    const entries = buttons.map(button => {
      const raw = button.getAttribute('data-filter') || '';
      const escaped = CSS.escape(raw);
      const inputSel = `input[name="${productTypeInputName}"][value="${escaped}"]`;
      return { button, value: raw, inputSel };
    });
  
    function updateButtonStates() {
      entries.forEach(({ button, inputSel }) => {
        const chk = document.querySelector(inputSel);
        const isActive = !!(chk && chk.checked);
        button.classList.toggle('active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
    }
  
    function onButtonClick(e) {
      const button = e.currentTarget;
      const meta = entries.find(x => x.button === button);
      if (!meta) return;
  
      const chk = document.querySelector(meta.inputSel);
      if (!chk) {
        console.warn(`Product type checkbox not found for value: ${meta.value}`);
        return;
      }
  
      // Toggle by clicking the real checkbox so the theme’s filter logic runs
      chk.click();
  
      // After theme scripts finish (URL refresh/ajax render), reflect state
      setTimeout(updateButtonStates, 120);
    }
  
    // Click handlers
    buttons.forEach(btn => btn.addEventListener('click', onButtonClick));
  
    // Keep in sync if user clicks native checkboxes or theme updates them
    filtersContainer.addEventListener('change', evt => {
      const t = evt.target;
      if (!(t instanceof HTMLInputElement)) return;
      if (t.getAttribute('name') === productTypeInputName) updateButtonStates();
    });
  
    // Observe collection section for re-renders (AJAX filter results, etc.)
    if (collectionSection) {
      let timer;
      const obs = new MutationObserver(() => {
        clearTimeout(timer);
        timer = setTimeout(updateButtonStates, 100);
      });
      obs.observe(collectionSection, { childList: true, subtree: true });
    }
  
    // Initial paint
    updateButtonStates();
  });
  

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
